import { gql } from '@apollo/client'
import { STORE_ADDRESS_FRAGMENT } from '../fragments'

export const GET_ADMIN_COMPANY_STORES_FOR_DOWNLOAD = gql`
  query AdminCompanyStoresForDownload($input: AdminCompanyStoresInput!) {
    adminCompanyStores(input: $input) {
      hasMore
      count
      results {
        id
        name
        internalStoreId
        category
        isActive
        address {
          ...StoreAddress
        }
        users {
          email
          isActive
        }
      }
    }
  }
  ${STORE_ADDRESS_FRAGMENT}
`
